import { Component } from '@angular/core';

@Component({
    selector: 'textarea[emsysInput]',
    template: '<ng-content></ng-content>',
    styleUrls: ['./form-textarea.component.scss'],
    standalone: false
})
export class FormTextareaComponent {

}
